import React from 'react';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { ProductTileModel } from '../../models/globals';
import { ProductTile } from '../common/ProductTile';
import { getColorClass } from '../../utilities/ProductUtilities';

interface PopularProductProps {
    headerTitle: string;
    popularProducts: ProductTileModel[];
}

const PopularProducts: React.FC<PopularProductProps> = ({ popularProducts, headerTitle }) => {
    if (!popularProducts.length) return null;

    return (
        <Container className="py-3 my-3">
            {/* Hide on screens md or larger */}
            <div className="d-md-none" data-testid="desktop-popular-products">
                <div className="border-bottom border-dark mb-4 pb-3">
                    <h2 className="font-weight-light text-muted text-left">{headerTitle}</h2>
                </div>
                {popularProducts.map(({ classification, title, typeName, detailPageUrl }) => (
                    <Button
                        key={detailPageUrl.url}
                        aria-label={title}
                        className="d-block pl-0 mt-3 text-reset text-decoration-none"
                        variant="link"
                        href={detailPageUrl.url}
                        data-testid={`popular-product-link-${detailPageUrl.url}`}
                    >
                        <span className="d-block font-weight-bold text-left">{title}</span>
                        <span className={`d-block text-left ${getColorClass({ classification })}`}>{typeName}</span>
                    </Button>
                ))}
            </div>

            {/* Hide on screens smaller than md */}
            <div className="d-none d-md-block" data-testid="mobile-popular-products">
                <h2 className="font-weight-light text-muted text-center">{headerTitle}</h2>
                <div className="mt-5 d-flex flex-row justify-content-center">
                    {popularProducts.map((product, index) => (
                        <div key={product.detailPageUrl.url} className="pr-5 popular-products-tile">
                            <ProductTile product={product} {...product} index={index} />
                        </div>
                    ))}
                </div>
            </div>
        </Container>
    );
};

export { PopularProducts, PopularProductProps };
